// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const Title = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorInsights.components.title"
        description="Title."
        defaultMessage="Community Audience"
    />
);
Title.displayName = "Title";

export const Subtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorInsights.components.subtitle"
        description="Subtitle."
        defaultMessage="Learn more about overall Lens Users on Snapchat, including who they are, where they are, and what devices they use."
    />
);
Subtitle.displayName = "Subtitle";

export const PotentialAudience = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorInsights.components.potentialAudience"
        description="Potential audience."
        defaultMessage="Potential Audience"
    />
);
PotentialAudience.displayName = "PotentialAudience";

export const Male = (): ReactElement => (
    <FormattedMessage id="apps.lensCreatorInsights.components.male" description="Male." defaultMessage="Male" />
);
Male.displayName = "Male";

export const Female = (): ReactElement => (
    <FormattedMessage id="apps.lensCreatorInsights.components.female" description="Female." defaultMessage="Female" />
);
Female.displayName = "Female";

export const AverageAge = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorInsights.components.averageAge"
        description="Average age."
        defaultMessage="Average Age"
    />
);
AverageAge.displayName = "AverageAge";

export const TopLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorInsights.components.topLenses"
        description="Top lenses."
        defaultMessage="Top Lenses"
    />
);
TopLenses.displayName = "TopLenses";

export const messages = defineMessages({
    deviceManufacturer: {
        id: "apps.lensCreatorInsights.components.deviceManufacturer",
        description: "Device manufacturer.",
        defaultMessage: "Device Manufacturer",
    },
    language: {
        id: "apps.lensCreatorInsights.components.language",
        description: "Language.",
        defaultMessage: "Language",
    },
    country: {
        id: "apps.lensCreatorInsights.components.country",
        description: "Country.",
        defaultMessage: "Country",
    },
    operatingSystem: {
        id: "apps.lensCreatorInsights.components.operatingSystem",
        description: "Operating system.",
        defaultMessage: "Operating System",
    },
});
